"use client";

import { useState } from "react";

export default function FooterNewsletter() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  };

  return (
    <div className="w-full sm:w-auto">
      {submitted ? (
        <p className="text-sm text-(--accent)">You&apos;re subscribed. Welcome aboard.</p>
      ) : (
        <form onSubmit={handleSubmit} className="flex w-full gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            required
            className="min-w-0 flex-1 rounded-lg border border-(--stroke) bg-(--panel) px-4 py-2.5 text-sm outline-none transition focus:border-(--accent) sm:w-64 sm:flex-none"
          />
          <button
            type="submit"
            className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-(--accent) px-4 py-2.5 text-sm font-semibold text-[#07111f] transition hover:brightness-110 sm:px-5"
          >
            Subscribe
          </button>
        </form>
      )}
    </div>
  );
}
